import React from "react";
import { Helmet } from "react-helmet";
import LiveHeader from "../common/LiveHeader";
import listingPerformance from "./images/listing-performance.png";
import listingPromotion from "./images/listing-promotion.png";
import matchingBuyers from "./images/matching-buyers.png";
import {
  Container,
  Description,
  SubTitle,
  Text,
  TextTitle,
  Title,
  PoweredByContainer
} from "./styled/live-rdc";
import {
  Feature,
  FeatureImage,
  Features
} from "./styled/live-rdc-listing-toolkit";
import LiveRdcPoweredBy from "./LiveRdcPoweredBy";

function LiveRdcListingToolkit() {
  return (
    <>
      <Helmet>
        <title>Realtor.com® Listing Toolkit</title>
      </Helmet>
      <LiveHeader>Realtor.com® Listing Toolkit</LiveHeader>
      <Container>
        <Title>What is the Realtor.com® Listing Toolkit?</Title>
        <Description>
          The Listing Toolkit gives me premium access to Realtor.com®'s local
          market data, potential buyers who might be interested in making offers
          on your home, tips to improve the performance of your home before it's
          published on the market, and analysis of how your home is performing
          compared to others in your area.
        </Description>
        <Features>
          <SubTitle>Features included in the Listing Toolkit</SubTitle>
          <div>
            <Feature>
              <FeatureImage src={matchingBuyers} alt="Matching Buyers" />
              <div>
                <TextTitle>Matching Buyers</TextTitle>
                <Text>
                  Realtor.com®'s Matching Buyers feature helps connect us with
                  the right buyers who are actively looking in your area, have a
                  budget that matches the listing price, and who are working
                  with a known agent. We can learn more about their preferences
                  and how they compare to buyers in nearby areas.
                </Text>
              </div>
            </Feature>
            <Feature>
              <FeatureImage src={listingPromotion} alt="Listing Promotion" />
              <div>
                <TextTitle>Listing Promotion</TextTitle>
                <Text>
                  With Realtor.com®'s powerful Listing Promotion tool, your
                  listing will be featured on the first pages of relevant
                  Realtor.com® search results. Positioning it to get the maximum
                  exposure will lead to receiving buyer feedback quickly.
                </Text>
              </div>
            </Feature>
            <Feature>
              <FeatureImage
                src={listingPerformance}
                alt="Listing Performance"
              />
              <div>
                <TextTitle>Listing Performance</TextTitle>
                <Text>
                  We can get Listing Performance insights comparing your
                  listing's performance to similar properties in the market to
                  make smart decisions on our next steps. We will also receive
                  insights like market trends, changes in your market, and from
                  where most of the potential buyers are moving with a similar
                  budget range.
                </Text>
              </div>
            </Feature>
          </div>
        </Features>
        <PoweredByContainer>
          <LiveRdcPoweredBy />
        </PoweredByContainer>
      </Container>
    </>
  );
}

export default LiveRdcListingToolkit;
